import { Col, Row, Skeleton } from "antd";

const HomeSkeleton: React.FC = () => (
  <Row
    style={{ background: "#10112a", minHeight: "100vh", padding: 32 }}
    justify="center"
  >
    <Col xs={24} md={12}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 32,
        }}
      >
        <Skeleton.Avatar active size={64} shape="circle" />
        <div
          style={{
            flex: 1,
            margin: "0 16px",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <Skeleton.Input
            active
            size="small"
            style={{ width: 180, marginBottom: 8 }}
          />
          <Skeleton.Input active size="default" style={{ width: 320 }} />
        </div>
        <Skeleton.Avatar active size={64} shape="circle" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Skeleton.Input
          active
          size="small"
          style={{ width: 50, borderRadius: 12, marginBottom: 0 }}
        />
        <Skeleton.Button
          active
          style={{
            width: "100%",
            flex: 1,
            height: 120,
            borderRadius: 12,
            marginBottom: 32,
          }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Skeleton.Input
          active
          size="small"
          style={{ width: 50, borderRadius: 12, marginBottom: 0 }}
        />
        <Skeleton.Button
          active
          style={{
            width: "100%",
            flex: 1,
            height: 120,
            borderRadius: 12,
            marginBottom: 32,
          }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Skeleton.Input
          active
          size="small"
          style={{ width: 50, borderRadius: 12, marginBottom: 0 }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: "100%", borderRadius: 12, marginBottom: 0 }}
        />
        <Skeleton.Button
          active
          style={{
            width: "100%",
            flex: 1,
            height: 120,
            borderRadius: 12,
            marginBottom: 32,
          }}
        />
      </div>
    </Col>
  </Row>
);

export default HomeSkeleton;
